var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 3,
    width: 18,
    height: 18,
    rx: 9,
    transform: "rotate(90 21 3)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6896_26797",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2,
    width: 20,
    height: 20,
    transform: "rotate(90 22 2)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6896_26797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 12.202L10.1 11.302C9.91667 11.1186 9.68333 11.027 9.4 11.027C9.11667 11.027 8.88333 11.1186 8.7 11.302C8.51667 11.4853 8.425 11.7186 8.425 12.002C8.425 12.2853 8.51667 12.5186 8.7 12.702L11.3 15.302C11.5 15.502 11.7333 15.602 12 15.602C12.2667 15.602 12.5 15.502 12.7 15.302L15.3 12.702C15.4833 12.5186 15.575 12.2853 15.575 12.002C15.575 11.7186 15.4833 11.4853 15.3 11.302C15.1167 11.1186 14.8833 11.027 14.6 11.027C14.3167 11.027 14.0833 11.1186 13.9 11.302L13 12.202L13 9.00195C13 8.71862 12.9042 8.48112 12.7125 8.28945C12.5208 8.09779 12.2833 8.00195 12 8.00195C11.7167 8.00195 11.4792 8.09779 11.2875 8.28945C11.0958 8.48112 11 8.71862 11 9.00195L11 12.202ZM2 12.002C2 10.6186 2.2625 9.31862 2.7875 8.10195C3.3125 6.88529 4.025 5.82695 4.925 4.92695C5.825 4.02695 6.88333 3.31445 8.1 2.78945C9.31667 2.26445 10.6167 2.00195 12 2.00195C13.3833 2.00195 14.6833 2.26445 15.9 2.78945C17.1167 3.31445 18.175 4.02695 19.075 4.92695C19.975 5.82695 20.6875 6.88529 21.2125 8.10195C21.7375 9.31862 22 10.6186 22 12.002C22 13.3853 21.7375 14.6853 21.2125 15.902C20.6875 17.1186 19.975 18.177 19.075 19.077C18.175 19.977 17.1167 20.6895 15.9 21.2145C14.6833 21.7395 13.3833 22.002 12 22.002C10.6167 22.002 9.31666 21.7395 8.1 21.2145C6.88333 20.6895 5.825 19.977 4.925 19.077C4.025 18.177 3.3125 17.1186 2.7875 15.902C2.2625 14.6853 2 13.3853 2 12.002ZM4 12.002C4 14.2353 4.775 16.127 6.325 17.677C7.875 19.227 9.76667 20.002 12 20.002C14.2333 20.002 16.125 19.227 17.675 17.677C19.225 16.127 20 14.2353 20 12.002C20 9.76862 19.225 7.87695 17.675 6.32695C16.125 4.77695 14.2333 4.00195 12 4.00195C9.76667 4.00195 7.875 4.77695 6.325 6.32695C4.775 7.87695 4 9.76862 4 12.002Z",
    fill: "#1D4650"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentStep);
export default __webpack_public_path__ + "static/media/current-step.48a59727e8568bb23a1bee23c2806442.svg";
export { ForwardRef as ReactComponent };